import script from "./WhatsNewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsNewModal.vue?vue&type=script&setup=true&lang=js"

import "./WhatsNewModal.vue?vue&type=style&index=0&id=34f4ba38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f4ba38"]])

export default __exports__